import {
  type LotteryId as LotteryMappingId,
  LotteryType,
  lotteryTypeByLotteryId,
} from '@lottocom/lottery-mapping'
import { computed } from 'vue'

import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

export function useLotteryType(lotteryId: LotteryId) {
  const lotteryType = computed(
    () => lotteryTypeByLotteryId[lotteryId as unknown as LotteryMappingId],
  )

  const isDateLottery = computed(() => lotteryType.value === LotteryType.DATE_LOTTERY)
  const isNumberLottery = computed(() => lotteryType.value === LotteryType.NUMBER_LOTTERY)
  const isPickLottery = computed(() => lotteryType.value === LotteryType.PICK_LOTTERY)

  return {
    isDateLottery,
    isNumberLottery,
    isPickLottery,
    lotteryType,
  }
}
